module.exports = __webpack_public_path__ + "static/yahoo-3c8038daa94388691f17ff5136cfbe21.svg";